import { Component } from '@angular/core';
import { Router, RouterOutlet, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { AnalyticsService } from './analytics.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  template: '<router-outlet></router-outlet>'
})
export class AppComponent {
  constructor(router: Router, analytics: AnalyticsService) {
    router.events.pipe(filter(e => e instanceof NavigationEnd)).subscribe(e => {
      analytics.pageView((e as NavigationEnd).urlAfterRedirects);
    });
  }
}
